module.exports = __webpack_public_path__ + "img/contact4.45da7284.png";